import { Component, OnInit } from '@angular/core'

@Component({
    selector: './drgs-videos',
    templateUrl: './drgs-videos.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class DRGSVideosComponent implements OnInit {

    ngOnInit() {

    }
}